import React, { useState, useEffect } from "react";
import { Button, Input } from "reactstrap";
import EmailTemplateSelect from "./EmailTemplateSelect/EmailTemplateSelect";
import SubjectSelect from "./SubjectSelect/SubjectSelect";

const EmailTitle = ({ formik, name, icon, allModuleData, jobStage, disabled=false }) => {
  const [subjectTemplateData, setSubjectTemplateData] = useState(null);
  const [subjectContent, setSubjectContent] = useState(null);
  const [defaultSubject, setDefaultSubject] = useState(null);

  useEffect(() => {
    if (allModuleData && jobStage) {
      const firstName = allModuleData?.Candidates?.basicInfo?.firstName || '';
      const lastName = allModuleData?.Candidates?.basicInfo?.lastName || '';
      const accountName = allModuleData?.Jobs?.jobInfo?.accountName || '';
      const jobTitle = allModuleData?.Jobs?.jobInfo?.jobTitle || '';
      const subject = `${jobStage}: ${accountName} | ${jobTitle} | ${firstName} ${lastName}`;
      setDefaultSubject(subject);
      formik.setFieldValue(name, subject);
    }
  }, [allModuleData, jobStage]);

  function stripHtml(html) {
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  function replaceValues(template, data) {
    return template.replace(/\${([^}]+)}/g, (match, p1) => {
      const keys = p1.split(".");
      let value = data;
      for (const key of keys) {
        value = value[key];
        if (value === undefined) {
          return match;
        }
      }
      return value;
    });
  }

  useEffect(() => {
    if (subjectTemplateData) {
      setSubjectContent(stripHtml(subjectTemplateData?.value?.content));
    }
  }, [subjectTemplateData]);

  useEffect(() => {
    if (subjectContent) {
      formik.setFieldValue(name, replaceValues(subjectContent, allModuleData));
    }
  }, [subjectContent]);

  return (
    <div className="d-flex align-items-center gap-2 ">
      <div
        style={{
          width: "40px",
        }}
      >
        <div
          className="px-1 py-0"
          style={{
            height: "28px",
            width: "28px",
            backgroundColor: "#F5F5F5",
            border: "1px solid #A8A8A8",
            color: "#7A7A7A",
            borderRadius: "5px",
          }}
        >
          {icon && icon}
        </div>
      </div>
      <div className="d-flex flex-row justify-content-between gap-3 w-100">
        <div className="subject-container d-flex flex-row align-items-center">
          <span className="text-muted me-2">Subject</span>
          <Input
            type="text"
            className="subject-input"
            name="subject"
            value={formik?.values?.[name]}
            onChange={(event) => {
              formik.setFieldValue(name, event.target.value);
            }}
            onBlur={formik.handleBlur}
            disabled={disabled}
            style={{
              color: disabled ? "#848888" : "#000000",
              backgroundColor: disabled && "transparent",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailTitle;
